import { Component, inject } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { LucideAngularModule, LucideIconData } from 'lucide-angular';
import { Assets } from '../../../core/constants/assets.constant';
import { Toast, ToastService } from '../../../core/services/toast.service';

@Component({
  selector: 'app-toast-notification',
  imports: [LucideAngularModule, TranslocoDirective],
  templateUrl: './toast-notification.component.html',
  styleUrl: './toast-notification.component.scss',
})
export class ToastNotificationComponent {
  protected readonly Assets = Assets;

  protected readonly toastService = inject(ToastService);

  protected titleKey(toast: Toast): string {
    return `common.toast_${toast.type}`;
  }

  protected statusIcon(toast: Toast): LucideIconData {
    switch (toast.type) {
      case 'success':
        return Assets.lucideIcons.check;
      case 'warning':
        return Assets.lucideIcons.alert;
      case 'error':
        return Assets.lucideIcons.cancel;
    }
  }
}
